import React, { Component } from "react";
import styled from "styled-components";

import { Slider as MaterialSlider } from "@mui/material";

import { FlexBox } from "js/react/components/LayoutGrid";
import { Gap } from "js/react/components/Gap";

import { NumericStepper } from "./NumericStepper";

const SliderContainer = styled.div`
    flex-grow: 2;

    .MuiSlider-markLabel {
        font-size: 10px;
    }

    .MuiSlider-valueLabel {
        span {
            span {
                color: white;
                font-weight: bold;
            }
        }
    }

    .MuiSlider-root {
        padding: 7px 0;
    }
`;

export class Slider extends Component {
    constructor(props) {
        super(props);

        this.isDragging = false;
    }

    handleSliderChange = (event, value) => {
        const { onChange = () => { }, onDragStart = () => { } } = this.props;
        if (!this.isDragging) {
            this.isDragging = true;
            onDragStart();
        }
        onChange(value);
    }

    handleSliderChangeCommitted = (event, value) => {
        const { onCommit = () => { } } = this.props;
        this.isDragging = false;
        onCommit(value);
    }

    handleNumericStepperChange = value => {
        const { onChange = () => { }, onCommit } = this.props;
        onChange(value);
        if (onCommit) {
            onCommit(value);
        }
    }

    render() {
        const { value, onChange = () => { }, onCommit = () => { }, showInput, marks, percent, decimals, min, max, step, width, fillWidth, disabled, ...rest } = this.props;

        const format = percent ? "percent" : "number";

        return (
            <FlexBox middle className="bai-slider" width={width} fillWidth={fillWidth}>
                <SliderContainer>
                    <MaterialSlider
                        {...rest}
                        value={value}
                        onChange={this.handleSliderChange}
                        onChangeCommitted={this.handleSliderChangeCommitted}
                        format={format}
                        decimals={decimals}
                        min={min}
                        max={max}
                        step={step}
                        marks={marks}
                        disabled={disabled}
                    />
                </SliderContainer>
                {showInput && <>
                    <Gap size={15} />
                    <NumericStepper
                        value={value}
                        onChange={this.handleNumericStepperChange}
                        format={format}
                        decimals={decimals}
                        min={min}
                        max={max}
                        step={step}
                        disabled={disabled}
                    />
                </>}
            </FlexBox>
        );
    }
}

